"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var can_activate_guard_service_1 = require("../common/services/can-activate-guard.service");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var personal_info_component_1 = require("./components/personal-info.component");
var can_deactivate_guard_service_1 = require("../common/services/can-deactivate-guard.service");
var routes = [
    { path: 'personal-info',
        component: personal_info_component_1.PersonalInfoComponent,
        canActivate: [can_activate_guard_service_1.CanActivateGuard],
        canDeactivate: [can_deactivate_guard_service_1.CanDeactivateGuard] }
];
var PersonalInfoRoutingModule = (function () {
    function PersonalInfoRoutingModule() {
    }
    return PersonalInfoRoutingModule;
}());
PersonalInfoRoutingModule = __decorate([
    core_1.NgModule({
        imports: [router_1.RouterModule.forChild(routes)]
    })
], PersonalInfoRoutingModule);
exports.PersonalInfoRoutingModule = PersonalInfoRoutingModule;
var pcroutes = [
    { path: 'personal-info',
        component: personal_info_component_1.PCPersonalInfoComponent,
        canActivate: [can_activate_guard_service_1.CanActivateGuard],
        canDeactivate: [can_deactivate_guard_service_1.CanDeactivateGuard] }
];
var PCPersonalInfoRoutingModule = (function () {
    function PCPersonalInfoRoutingModule() {
    }
    return PCPersonalInfoRoutingModule;
}());
PCPersonalInfoRoutingModule = __decorate([
    core_1.NgModule({
        imports: [router_1.RouterModule.forChild(pcroutes)]
    })
], PCPersonalInfoRoutingModule);
exports.PCPersonalInfoRoutingModule = PCPersonalInfoRoutingModule;
